module.exports = __webpack_public_path__ + "static/media/CIAP-04.ef93fd08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Experience/Events/CIAP-04.jpg
// module id = 638
// module chunks = 0